import React, { useEffect, useState } from "react";

import HttpManager from "../../../services/HttpManager";
import { MisVentas } from "../../../services/v2/prospects.service";
import { dinero, errorTexto, SIMBOLO_PLANTEL } from "./salesHelpers";

interface Props { campusId: number; onSalir: () => void; }

const num = (v: number) => Number(v).toLocaleString("es-MX", { maximumFractionDigits: 1 });
const dia = (f: string) => { const [, m, d] = f.split("-"); return `${d}/${m}`; };

/**
 * «Mis ventas» (Esteban, 2026-10-30): cada asesora ve solo lo que vendió, sin poder cambiar nada, de mayo 2025 en adelante.
 * Desde el 24-sep-2026 la lista de WAPP con el nombre de cada cliente; antes, sus números según el informe hecho a mano y los
 * nombres que se pudieron cruzar con las matrículas.
 */
const MisVentasView: React.FC<Props> = ({ campusId, onSalir }) => {
	const http = HttpManager.getInstance();
	const [mes, setMes] = useState<string | null>(null);
	const [d, setD] = useState<MisVentas | null>(null);
	const [error, setError] = useState<string | null>(null);
	const sim = SIMBOLO_PLANTEL[campusId] || "";

	useEffect(() => {
		setD(null);
		setError(null);
		http.prospectsService.misVentas(campusId, mes).then((r) => setD(r.data)).catch((e) => setError(errorTexto(e)));
	}, [campusId, mes]);

	const cruzadas = d ? d.clientes.filter((c) => c.fuente === "cruce").length : 0;

	return (
		<div className="tb">
			<div className="tb-cab">
				<div>
					<h2>Mis ventas</h2>
					<span className="apagado">{d ? d.mesTexto : ""}</span>
				</div>
				<div className="tb-herr">
					<select value={mes || d?.mes || ""} onChange={(e) => setMes(e.target.value)} aria-label="Mes">
						{(d?.meses || []).map((m) => <option key={m.mes} value={m.mes}>{m.texto}</option>)}
					</select>
					<button className="enlace" onClick={onSalir}>Volver a la bandeja</button>
				</div>
			</div>
			{error ? <div className="aviso error">{error}</div> : null}
			{!d ? (error ? null : <div className="ventas-vacio">Cargando…</div>) : (
				<div className="tb-cuerpo">
					{d.fuente !== "wapp" ? (
						<div className="aviso">{d.fuente === "informe"
							? "Según el informe de ventas hecho a mano: antes del 24 de septiembre de 2026 no había solicitudes en WAPP."
							: "Del 1 al 23 según el informe de ventas hecho a mano; desde el 24 las solicitudes de WAPP."}</div>
					) : null}
					<div className="tb-kpis">
						<div className="tb-kpi"><span>Matrículas</span><b>{num(d.matriculas)}</b></div>
						{d.montoInforme !== null ? <div className="tb-kpi"><span>Monto (informe)</span><b>{dinero(d.montoInforme, sim)}</b></div> : null}
					</div>
					{d.fuente !== "wapp" ? (
						<div className="tarjeta">
							<div className="tarjeta-cab"><h4>Según el informe</h4><span className="apagado">{d.dias.length ? "" : "El informe no trae ventas tuyas este mes."}</span></div>
							{d.dias.length ? (
								<table className="tb-tabla">
									<thead><tr><th>Día</th><th>Equipo</th><th>Mat</th><th>Monto</th></tr></thead>
									<tbody>{d.dias.map((x, i) => (
										<tr key={x.fecha + i}><td>{x.semana ? "Semana del " + dia(x.fecha) : dia(x.fecha)}</td><td className="apagado">{x.equipo}</td>
											<td>{num(x.matriculas)}</td><td>{x.monto === null ? "" : dinero(x.monto, sim)}</td></tr>
									))}</tbody>
								</table>
							) : null}
						</div>
					) : null}
					<div className="tarjeta">
						<div className="tarjeta-cab">
							<h4>Clientes</h4>
							<span className="apagado">{d.clientes.length}{cruzadas ? " · " + cruzadas + " del informe que se encontraron en las matrículas de WAPP" : ""}</span>
						</div>
						{d.clientes.length ? (
							<div className="waScrollX">
								<table className="tb-tabla">
									<thead><tr><th>Fecha</th><th>Cliente</th><th>Curso</th><th>Cuenta</th></tr></thead>
									<tbody>{d.clientes.map((c, i) => (
										<tr key={c.fecha + c.cliente + i}><td style={{ whiteSpace: "nowrap" }}>{dia(c.fecha)}</td><td>{c.cliente}</td><td>{c.curso}</td>
											<td>{c.valor === 1 ? "1" : c.valor === 0.5 ? "½" : num(c.valor)}</td></tr>
									))}</tbody>
								</table>
							</div>
						) : <span className="apagado">{d.fuente === "wapp" ? "Todavía no hay ventas tuyas este mes." : "No se encontraron tus clientes de este mes en las matrículas de WAPP."}</span>}
					</div>
				</div>
			)}
		</div>
	);
};

export default MisVentasView;
